import { Avatar, AvatarProps, Box, styled } from '@mui/material';
import { memo } from 'react';
import AIAgentBorder from './AIAgentBorder';

const AIAgentAvatarInner = styled(Avatar)<AvatarProps>(() => ({
  borderRadius: 0,
  clipPath: 'polygon(50% 0%, 95% 25%, 95% 75%, 50% 100%, 5% 75%, 5% 25%)',
}));

interface AIAgentAvatarProps extends AvatarProps{
  width?: number,
  height?: number,
}
const AIAgentAvatar: React.FC<AIAgentAvatarProps> = (props) => {
  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        transform: 'translate3d(0, 0, 0)',
        backfaceVisibility: 'hidden',
        perspective: 1000,
      }}
    >
      <AIAgentAvatarInner
        {...props}
        slotProps={{
          img: {
            loading: 'lazy',
          },
        }}
      />
      <AIAgentBorder width={props.width && props.width* 1.04} height={props.height && props.height* 1.04}/>
    </Box>
  );
};

export default memo(AIAgentAvatar);
